import React, { useContext, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";

export default function Redefinicao() {
  const [dados, setDados] = useState({ CPF: "", naoEnviarEmail: false });
  const [resultado, setResultado] = useState({});
  const { notification } = useContext(AppContext);

  const solicitar = (params) => {
    let dadosParams = dados;
    dadosParams.CPF = params.CPF;
    dadosParams.naoEnviarEmail = params.naoEnviarEmail;

    setDados(dadosParams);

    api
      .post("usuarios/solicitarRedefinicaoSenhaAdm", params)
      .then((res) => {
        notification("success", "Redefinição solicitada com sucesso");
        setResultado(res);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Usuário com email inválido");
          case 2:
            return notification(
              "error",
              "Configuração incorreta de parâmetros para geração do link de recuperação"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const filtros = {
    title: "Usuário",
    form: {
      CPF: {
        label: "CPF",
        type: "number",
        space: 8,
        value: dados.CPF,
      },
      naoEnviarEmail: {
        label: "Enviar email",
        type: "check",
        space: 4,
        value: dados.naoEnviarEmail,
      },
    },

    submit: {
      label: "Solicitar",
      action: solicitar,
    },
  };

  const fDados = {
    title: "Dados Da Solicitação",
    form: {
      link: {
        label: "Componente",
        type: "component",
        value: (
          <>
            <h4>Link de recuperação</h4>
            <a href={resultado.urlRecuperacao} target="_blank">
              {resultado.urlRecuperacao}
            </a>
          </>
        ),
      },
      email: {
        label: "Componente",
        type: "component",
        value: (
          <>
            <h4>Email do usuário</h4>
            <p>{resultado.email}</p>
          </>
        ),
      },
    },
  };

  return (
    <div>
      <Form formData={filtros} />
      {resultado.urlRecuperacao && <Form formData={fDados} />}
    </div>
  );
}
